import '@/assets/styles/index.scss'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './static/css/main.css'
import axios from 'axios'

import store from './store'
import components from '@/components'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
import './assets/styles/element-icons.css'

// 总线bus
Vue.prototype.$bus = new Vue()
Vue.use(ElementUI)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueBus from 'vue-bus'
Vue.use(VueBus)

//axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//axios.defaults.headers.common["Content-Type"] =  'application/json'
Vue.prototype.$axios = axios

Vue.config.productionTip = false
Vue.use(components)

import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js